import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({
  scale,
  verticalOffset = 0,
  gradientStop1 = '#53533F',
  gradientStop2 = '#010101',
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`
  const transformOrigin = '21.98 7.89'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M19.1802 5.75991C19.1802 5.75991 21.9102 4.18991 24.8202 5.75991"
        stroke="#FCE5AC"
        strokeMiterlimit="10"
      />
      <path
        d="M9.55004 0.569964C13.68 0.489964 18.3401 1.21992 18.8801 4.27992C19.3601 7.04992 17.34 14.75 10 15.1C2.66005 15.45 0.610045 7.62999 1.56005 4.09999C2.35005 1.13999 5.28004 0.659964 9.55004 0.569964Z"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M34.37 0.569964C30.24 0.489964 25.58 1.21992 25.04 4.27992C24.56 7.04992 26.58 14.75 33.92 15.1C41.26 15.45 43.31 7.62999 42.36 4.09999C41.57 1.13999 38.64 0.659964 34.37 0.569964Z"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M9.55004 0.679949C13.68 0.599949 18.3401 1.32991 18.8801 4.38991C19.3601 7.15991 17.34 14.86 10 15.21C2.66005 15.56 0.610045 7.73998 1.56005 4.20998C2.35005 1.24998 5.28004 0.769949 9.55004 0.679949Z"
        stroke="#FCE5AC"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M34.37 0.679949C30.24 0.599949 25.58 1.32991 25.04 4.38991C24.56 7.15991 26.58 14.86 33.92 15.21C41.26 15.56 43.31 7.73998 42.36 4.20998C41.57 1.24998 38.64 0.769949 34.37 0.679949Z"
        stroke="#FCE5AC"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="10.1384"
          y1="2.19137"
          x2="10.1384"
          y2="16.7235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="33.78"
          y1="2.19137"
          x2="33.78"
          y2="16.7235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
      </defs>
    </g>
  )
}
